module.exports = __webpack_public_path__ + "img/sitting.1006175f.jpg";